import {EventEmitter} from './index';
import {
    GL_USER_CONFIG_UPDATED, 
    GL_NEXT_DATA_TO_STATE, 
    GLOBAL_ACCOUNT_CONFIG,
    PAGE_RECEIVED_DATA
} from './actions';


class GlobalState {
    constructor() {
        this.store = {
            CRMId: null,
            loggedIn: false,
            appLoading: false,
            userConfig: null
        }
    }

    loadInitialData() {
        this.store = {
            ...this.store,
            ...window.serverData,
            loggedIn: window.serverData.CRMId !== -1
        }

        if (this.store.loggedIn && !this.store.userConfig) {
            this.fetchUserConfig(GLOBAL_ACCOUNT_CONFIG);
        }
    }

    fetchUserConfig(url) {
        let self = this;

        return $.get(url).done(resp => {
            resp.forEach(data => {
                console.log(data.customer, self.store.CRMId)
                if (data.customer === self.store.CRMId) {
                    self.updateStore({userConfig: data});

                    let interval = setInterval(() => {
                        console.log("sending data")
                        self.dispatch(GL_USER_CONFIG_UPDATED, JSON.stringify(data));
                    }, 300);
                    
                    self.listen(PAGE_RECEIVED_DATA, () => {
                        clearInterval(interval);
                    })

                    setTimeout(() => {
                        clearInterval(interval);
                    }, 10000)
                    
                }
            });
        })
    }

    updateStore(newData) {
        this.dispatch(GL_NEXT_DATA_TO_STATE, newData);
        this.store = {
            ...this.store,
            ...newData
        }
    }

    dispatch(eventName, data) {(EventEmitter.emit(eventName, data))}

    listen(eventNames, func) {(EventEmitter.on(eventNames, func))}

    cancel(eventNames, func) {(EventEmitter.off(eventNames, func))}

    listenOnce(eventNames, callback) {
        EventEmitter.on(eventNames, function () {
            EventEmitter.off(eventNames, () => {});
            return callback()
        });
    }
}

const StateModule = new GlobalState();

export default StateModule;
